import { LOGIN_REG_MODAL_STATE } from "../core/constants";
import { getComponentData, setComponentData } from "../core/views";

export const resetDismissedLogin = () : void => {
  const modalState = getComponentData(LOGIN_REG_MODAL_STATE);
  modalState.loginDismissed = false;
  setComponentData(LOGIN_REG_MODAL_STATE, modalState);
  localStorage.removeItem("NoLogin");
}

export const dismissLogin = () : void => {
  const start = Date.now();
  localStorage.setItem("NoLogin", `${start}`);
  const modalState = getComponentData(LOGIN_REG_MODAL_STATE);
  modalState.loginDismissed = true;
  setComponentData(LOGIN_REG_MODAL_STATE, modalState);
}

export const wasLoginDismissed = () : boolean => {
  const item : string = localStorage.getItem("NoLogin") || "";
  if (item.length <= 0) return false;
  const dismissedAt : number = parseInt(item, 10);
  if (!dismissedAt) {
    return false;
  }

  const start = Date.now();
  const timeout = 120;
  const milliToMin = 60000;
  return ((start - dismissedAt) < (timeout * milliToMin));
}
